export const styles = {
  footnote: {
    color: '#7c7c7c',
    fontSize: '14px',
    margin: ' -30px 0 40px',
  },
}
